module.exports = __webpack_public_path__ + "4997af66673861d83a09c5f421119398.png";


//////////////////
// WEBPACK FOOTER
// ./js/img/map/2.png
// module id = 1349
// module chunks = 0